import React, { Component } from 'react';
import style from './SelectClient.css';
export class SelectClient extends Component {
    constructor(props){
        super(props)
        this.state = {
            idClientDefault: 1
        };
        
        this.onSelectClientChanged = (evt) => {
            const idClient = evt.target.value
            this.setState({idClientDefault: idClient})
            this.props.onSelectClientChanged(idClient)
        };
    }
    
    render(){
        return (
            <div className={`col-md-2 ${style.SelectClient_div}`}>
                <select className="form-control"  name="selectCliente"
                    value={this.state.idClientDefault} 
                    onChange={this.onSelectClientChanged}
                >
                    
                    {this.props.clients.map((client, index)=>{
                        return <option key={index} value={client.idCliente}>{client.nombre}</option>
                    })}
                </select>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./frontEnd/admin/stockStoreUpdate/components/SelectClient.jsx